import React, { ReactElement, useCallback, useState } from 'react';

import { HowTo, HowtoSlideDown } from './styles';

export interface Props {
  title: string;
  children: JSX.Element[] | ReactElement[] | JSX.Element;
}

const AutoHowTo = ({ title, children }: Props) => {
  const [active, setActive] = useState(false);

  const toggle = useCallback(() => setActive(!active), [active, setActive]);

  return (
    <HowTo>
      <HowTo.Header onClick={toggle}>
        <HowTo.Title>{title}</HowTo.Title>
        <HowTo.Icon className={active ? 'active' : ''} />
      </HowTo.Header>
      <HowtoSlideDown transitionOnAppear={false} closed={!active}>
        <HowTo.Body>{children}</HowTo.Body>
      </HowtoSlideDown>
    </HowTo>
  );
};

export default AutoHowTo;
